import { Link, IconOpenInNew } from 'cdk-radial';
import { LinkRendererProps } from './types';

export const LinkRenderer = ({
  linkText,
  linkIconPosition,
  target,
  path,
  handleClick
}: LinkRendererProps): React.JSX.Element => (
  <Link
    icon={<IconOpenInNew />}
    href={path}
    target={target}
    text={linkText}
    iconPosition={linkIconPosition}
    onClick={handleClick}
  />
);
